import React, { useState, useRef } from 'react';
import { Box } from '@mui/material';
import FlexDivider from "../../../Miscellaneous/FlexDivider";
import Metric from "./Metric/Metric.js"
import SourceDocument from "./SourceDocument/SourceDocument.js"
import "./CompanyDetail.css";

function CompanyDetail() {
    const [paneHeights, setPaneHeights] = useState([50, 50]);
    const containerRef = useRef(null);

    const onDrag = (e, index) => {
      const newHeights = [...paneHeights];
      const containerRect = containerRef.current.getBoundingClientRect();
      const mousePositionPercent = ((e.clientY - containerRect.top) / containerRect.height) * 100;

      if (index === 0) {
        newHeights[0] = mousePositionPercent;
        newHeights[1] = 100 - mousePositionPercent;
      }

      setPaneHeights(newHeights);
    };
    
    return (
        <Box className="company-detail-container" ref={containerRef}>
          <Box height={`${paneHeights[0]}%`} className="metric-container">
            <Metric />
          </Box>
          <FlexDivider onDrag={onDrag} index={0} direction="horizontal" />
          <Box height={`${paneHeights[1]}%`} className="source-document-container">
            <SourceDocument />
          </Box>
        </Box>
    );
}

export default CompanyDetail;
